<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12" md="6" xl="4">
              <v-select
                v-model="conceptoUniversidadId"
                :items="conceptosUniversidades"
                label="Concepto Universidad"
                outlined
                dense
                hide-details
                item-text="concepto.nombre"
                item-value="id"
                :clearable="accion === accionesCrud.REGISTRAR"
                :readonly="accion === accionesCrud.EDITAR"
                @change="onChangeConceptoUniversidad">
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ item.concepto.nombre }}</v-list-item-title>
                    <v-list-item-subtitle class="subtitle-2 text-uppercase">
                      <small>{{ item.institucion.nombre }}</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" md="6" xl="8">
              <v-btn
                class="mx-1"
                color="primary"
                title="Registrar"
                small
                :disabled="conceptoUniversidadId == null"
                @click="$refs.modalFormularioSolicitudPagoAgrupadoRef.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Agregar Solicitud de Pago
              </v-btn>

              <v-btn small class="mx-1" :disabled="item == null" title="Quitar" @click="() => quitarItem(item)">
                <v-icon>mdi-close</v-icon>

                Quitar
              </v-btn>
            </v-col>

            <v-col cols="12">
              <ListadoSolicitudesPagosAgregados
                ref="listadoSolicitudesPagosAgregadosRef"
                :cargando="false"
                :items="form?.solicitudesPagos || []"
                @selectItem="selectItem" />
            </v-col>
          </v-row>

          <ModalFormularioSolicitudPagoAgrupado
            ref="modalFormularioSolicitudPagoAgrupadoRef"
            nombreRecurso="Solicitud de Pago Agrupado"
            :conceptoUniversidadId="conceptoUniversidadId"
            @agregarSolicitudPago="agregarSolicitudPago" />
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="enviando" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          :disabled="enviando"
          :loading="enviando"
          text
          @click.prevent="$refs.confirmacionRef1.abrir">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef1"
      :titulo="confirmacion1.titulo"
      :mensaje="confirmacion1.mensaje"
      :realizandoAccion="confirmacion1.realizandoAccion"
      @aceptar="confirmacion1.fnAceptar" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import SolicitudPagoPadreService from '../services/solicitud-pago-padre.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import layoutMixin from '../mixins/layout.mixin';
import ModalFormularioSolicitudPagoAgrupado from './ModalFormularioSolicitudPagoAgrupado.vue';
import ListadoSolicitudesPagosAgregados from './ListadoSolicitudesPagosAgregados.vue';
import ConceptoUniversidadService from '../services/concepto-universidad.service';
import { concatenar } from '../utils/funciones';

export default {
  name: 'ModalFormularioSolicitudesPagosAgrupados',
  mixins: [modalFormMixin, apiConsumerMixin, layoutMixin],
  components: {
    ModalFormularioSolicitudPagoAgrupado,
    ListadoSolicitudesPagosAgregados,
  },
  data() {
    return {
      confirmacion1: {
        titulo: 'Guardar Solicitud de Pago',
        mensaje: '¿Está seguro que desea realizar la solicitud de pago?',
        realizandoAccion: false,
        fnAceptar: () => this.validar(this.registrar, this.editar),
      },
      conceptosUniversidades: [],
      conceptoUniversidadId: null,
      accion: null,
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        solicitanteId: this.$store.state.DATA_USER.id,
        nombreSolicitante: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
        sedeId: this.$store.state.cargo_sede?.sede?.id,
        solicitudesPagos: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        solicitanteId: data.solicitanteId,
        nombreSolicitante: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
        sedeId: this.$store.state.cargo_sede?.sede?.id,
        solicitudesPagos: data.solicitudesPagos,
      };
    },
    abrir(accion, data = []) {
      this.conceptoUniversidadId = null;

      this.obtenerConceptosUniversidades().then(() => {
        this.accion = accion;
        this.abrirMixin(accion, data);

        if (accion === this.accionesCrud.EDITAR) {
          this.conceptoUniversidadId =
            this.form.solicitudesPagos[0]?.detallePlanPagoConceptoUniversidad?.planPagoConceptoUniversidad?.conceptoUniversidadId;
        }
      });
    },
    async registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    async editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
    async guardar(accion) {
      this.guardarDatosMixin(
        SolicitudPagoPadreService.create,
        SolicitudPagoPadreService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.areasUniversidades = [];
          this.categoriasUniversidades = [];
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    agregarSolicitudPago(solicitudPago) {
      const indiceSolicitudPago = this.form.solicitudesPagos.findIndex(
        (solictitud) =>
          solictitud.programaUniversidadId === solicitudPago.programaUniversidadId &&
          solictitud.detallePlanPagoConceptoUniversidadId === solicitudPago.detallePlanPagoConceptoUniversidadId &&
          solictitud.numeroCuota === solicitudPago.numeroCuota,
      );

      if (indiceSolicitudPago === -1) {
        this.form.solicitudesPagos.push(solicitudPago);
      } else {
        solicitudPago.detallesSolicitudesPagos.forEach((detalleSolicitudPago) => {
          const indiceDetalleSolicitudPago = this.form.solicitudesPagos[
            indiceSolicitudPago
          ].detallesSolicitudesPagos.findIndex(
            (detalle) =>
              detalle.inscripcionProgramaUniversidadId === detalleSolicitudPago.inscripcionProgramaUniversidadId,
          );

          if (indiceDetalleSolicitudPago == -1) {
            this.form.solicitudesPagos[indiceSolicitudPago].detallesSolicitudesPagos.push(detalleSolicitudPago);
          }
        });
      }
    },
    quitarItem(item) {
      const indiceSolicitudPago = this.form.solicitudesPagos.findIndex(
        (solictitud) =>
          solictitud.programaUniversidadId === item.programaUniversidadId &&
          solictitud.detallePlanPagoConceptoUniversidadId === item.detallePlanPagoConceptoUniversidadId,
      );

      if (indiceSolicitudPago !== -1) {
        const indiceDetalleSolicitudPago = this.form.solicitudesPagos[
          indiceSolicitudPago
        ].detallesSolicitudesPagos.findIndex(
          (detalle) => detalle.inscripcionProgramaUniversidadId === item.inscripcionProgramaUniversidadId,
        );

        if (indiceDetalleSolicitudPago !== -1) {
          this.form.solicitudesPagos[indiceSolicitudPago].detallesSolicitudesPagos.splice(
            indiceDetalleSolicitudPago,
            1,
          );

          if (this.form.solicitudesPagos[indiceSolicitudPago].detallesSolicitudesPagos.length === 0) {
            this.form.solicitudesPagos.splice(indiceSolicitudPago, 1);
          }
        }
      }
    },
    obtenerConceptosUniversidades() {
      return this.obtenerDatosV2Mixin(
        ConceptoUniversidadService.findAllBySedeId,
        'conceptosUniversidades',
        this.$store.state.CARGO.sede.id,
        {},
      );
    },
    onChangeConceptoUniversidad() {
      if (this.accion === this.accionesCrud.REGISTRAR) {
        this.form.solicitudesPagos = [];
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>